import gsap from "gsap";
import Sine from "gsap";
import _ from "lodash";
import { setActiveScroll, setMovables, handleScroll } from "./handleScroll";
import { handleLogo, setUpLogo } from "./handleLogo";
import { initiateSlideshow } from "./handleSlideshow";
import imagesLoaded from "imagesloaded";

function setUpPage(setUpArgs) {
  const { logoLoad, logoHome, logoArrow, slideShowContainer } = setUpArgs;
  const noImages = document.getElementById("no_images");
  const isIntro = document.getElementById("landing-page-container") !== null;
  setUpLogo(logoArrow, logoLoad);
  if (slideShowContainer !== null || noImages !== null) {
    initiateSlideshow(logoLoad, logoHome, logoArrow);
  } else if (!isIntro) {
    setMovables(Array.from(document.querySelectorAll(".overlap")));
    document.addEventListener("scroll", _.debounce(handleScroll, 5));
  }
}

function animateBar(loaderArgs, progress) {
  const {
    loaderContainer,
    loaderBar,
    mainContainer,
    logoLoad,
    menuContainer,
  } = loaderArgs;
  if (progress === 1) {
    const containerAnimation = gsap.timeline();
    containerAnimation.to(loaderBar, {
      duration: 0.2,
      width: "100%",
      ease: Sine.easeOut,
    });
    containerAnimation.to(loaderContainer, {
      duration: 0.6,
      width: "0%",
      ease: Sine.easeOut,
    });
    containerAnimation.to(loaderContainer, {
      opacity: 0,
      duration: 0.5,
      ease: Sine.easeOut,
    });
    containerAnimation.to(logoLoad, {
      opacity: 0,
      duration: 0.2,
      onComplete: function() {
        setUpPage(loaderArgs);
        handleLogo(true);
      },
    });
    containerAnimation.to(mainContainer, {
      opacity: 1,
      duration: 0.3,
      ease: Sine.easeOut,
      onComplete: function() {
        if (menuContainer) {
          menuContainer.classList.add("show");
        }
        setTimeout(() => {
          setActiveScroll(true);
          handleLogo(true);
        }, 100);
      },
    });
  } else {
    gsap.to(loaderBar, {
      duration: 0.2,
      width: progress * 100 + "%",
      ease: Sine.easeOut,
    });
  }
}

const handleLoadBackground = function(image, bg) {
  bg.style.backgroundImage = "url(" + image.src + ")";
  bg.style.backgroundPosition = "center center";
  bg.style.backgroundSize = "cover";
};

const handleLoading = function(loaderArgs) {
  const images = Array.from(document.querySelectorAll("img"));
  const lazyBgs = Array.from(document.querySelectorAll(".lazy-back"));
  lazyBgs.forEach((bg) => {
    const src = bg.dataset.src;
    if (src !== undefined) {
      const image = new Image();
      image.src = src;
      image.onload = handleLoadBackground(image, bg);
      images.push(image);
    }
  });
  const videos = Array.from(document.querySelectorAll("video"));
  videos.forEach((video) => {
    let image = new Image();
    let posterImage = video.getAttribute("poster");
    if (posterImage) {
      image.src = posterImage;
    }
    images.push(image);
  });
  if (images !== null && images.length > 0) {
    let imgLoad = imagesLoaded(images);
    imgLoad.on("progress", function(instance, image) {
      const completion = instance.progressedCount / instance.elements.length;
      animateBar(loaderArgs, completion);
    });
  } else {
    animateBar(loaderArgs, 1);
  }
};

export const handleLoader = function(loaderArgs) {
  handleLoading(loaderArgs);
};
